import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Card } from "../components/ui/card";
import { CheckCircle, XCircle, RefreshCw } from "lucide-react";
import { toast } from "sonner";

export default function OutlookCallback() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("processing");
  const [message, setMessage] = useState("Connecting your Outlook calendar...");
  const [connectedEmail, setConnectedEmail] = useState("");

  useEffect(() => {
    handleCallback();
  }, []);

  const handleCallback = () => {
    const success = searchParams.get("success");
    const email = searchParams.get("email");
    const error = searchParams.get("error");

    if (success === "true") {
      setStatus("success");
      setConnectedEmail(email || "Outlook");
      setMessage(`Successfully connected to ${email || "Outlook"}`);
      toast.success(`Connected to ${email || "Outlook"}!`);
      // Don't auto-redirect - let user choose where to go
      
    } else if (error) {
      setStatus("error");
      
      const errorMessages = {
        "invalid_state": "Session expired. Please try again.",
        "not_authenticated": "Please log in and try again.",
        "session_expired": "Your session expired. Please log in again.",
        "token_exchange_failed": "Failed to connect to Microsoft. Please try again.",
        "callback_failed": "Connection failed. Please try again.",
        "access_denied": "Access was denied. Please grant calendar permissions.",
        "user_not_found": "User account not found. Please log in again and retry.",
        "save_failed": "Failed to save connection. Please try again."
      };
      
      setMessage(errorMessages[error] || `Connection failed: ${error}`);
      toast.error(errorMessages[error] || "Connection failed");
      
    } else {
      setStatus("processing");
      setMessage("Connecting...");
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0f1a] flex items-center justify-center p-4">
      <Card className="max-w-md w-full p-8">
        <div className="text-center">
          {status === "processing" && (
            <>
              <RefreshCw className="w-16 h-16 mx-auto mb-4 text-blue-400 animate-spin" />
              <h2 className="text-xl font-bold text-white mb-2">Connecting...</h2>
              <p className="text-slate-400">{message}</p>
            </>
          )}

          {status === "success" && (
            <>
              <CheckCircle className="w-16 h-16 mx-auto mb-4 text-emerald-400" />
              <h2 className="text-xl font-bold text-white mb-2">Success!</h2>
              <p className="text-slate-400 mb-2">{message}</p>
              <p className="text-emerald-400 font-bold text-lg mb-6">✓ {connectedEmail}</p>
              
              <div className="space-y-3">
                <button
                  onClick={() => window.location.href = "/committee-availability"}
                  className="w-full px-4 py-3 bg-yellow-500 hover:bg-yellow-400 text-black font-bold rounded-lg"
                >
                  Go to Committee Availability
                </button>
                <button
                  onClick={() => window.location.href = "/dashboard"}
                  className="w-full px-4 py-3 bg-slate-700 hover:bg-slate-600 text-white rounded-lg"
                >
                  Go to Dashboard
                </button>
              </div>
            </>
          )}

          {status === "error" && (
            <>
              <XCircle className="w-16 h-16 mx-auto mb-4 text-red-400" />
              <h2 className="text-xl font-bold text-white mb-2">Connection Failed</h2>
              <p className="text-slate-400 mb-6">{message}</p>
              <button
                onClick={() => window.location.href = "/committee-availability"}
                className="w-full px-4 py-3 bg-slate-700 hover:bg-slate-600 text-white rounded-lg"
              >
                Try Again
              </button>
            </>
          )}
        </div>
      </Card>
    </div>
  );
}
